<div [ngClass]="{ outOfFocus: outOfFocus }">
  <button [class.opened]="emojiPicker.isOpen || emojiPicker.isLoading" (click)="emojiPicker.toggle()" aria-label="emoji picker" type="button" tabindex="-1">
    <rich-text-editor-icon [icon]="emojiIcon" [outOfFocus]="outOfFocus"></rich-text-editor-icon>
  </button>
</div>
